import state from './login.state'
import mutations from './login.mutations'
import actions from './login.actions'
import getters from './login.getters'

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
